import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const container = styled('div')`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(128, 111, 102, 0.5);
  z-index: 9999;
`;

const containerInner = styled('div')`
  position: absolute;
  left: calc(50% - 400px);
  top: 15%;
  max-height: 70%;
  margin: auto;
  box-shadow: var(--ph-box-shadow-sm);
  background-color: var(--white);
  padding: 20px;
  overflow-y: auto;
  width: 800px;

  h1 {
    margin: 5px 45px 15px 0;
    white-space: normal;
    font-size: var(--ph-heading-three);
  }

  &.level-2 {
    left: calc(50% - 250px);
    top: 20%;
    max-height: 50%;
    width: 500px;

    h1 {
      font-size: var(--ph-heading-three);
    }
  }

  &.level-3 {
    width: 680px;
  }

  &.withOverflow {
    overflow-y: visible;
  }

  &.withFlex {
    display: flex;
    flex-direction: column;
  }
`;

const closeBtn = styled(Svg)`
  width: 15px;
  height: 15px;
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 20px;

  path {
    transition: var(--ph-transition);
    fill: var(--dark-grey);
  }

  &:hover path {
    fill: var(--ph-red-500);
  }
`;

const section = styled('div')`
  & + & {
    border-top: var(--light-grey) 1px solid;
    margin: 30px -40px 0;
    padding: 20px 40px 0;
  }
`;

export default {
  Container: container,
  ContainerInner: containerInner,
  CloseBtn: closeBtn,
  Section: section,
};
